import React, {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here

const removeIcon = require("./../assets/img/remove-icon.svg").default;
const viewIcon = require("./../assets/img/eye-icon.svg").default;

const ChangePassword = () => {
  const [userData, setUserData] = useState(null);
  const [notificationList, setNotificationList] = useState([]);

  const fetchNotifications = () => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    fetch(`https://cliqestimatebuilder.com/waiver_admin/notifications/`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
      method: "GET",
    })
      .then(response => response.json())
      .then(data => {
        if (data.res == 1) {
          if (data.data) {
            setNotificationList(data.data);
          } else {
            setNotificationList([]);
          }
        }
      })
      .catch(error => console.error("Error fetching file data:", error));
  };

  const deleteAllNotifications = () => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    fetch(`https://cliqestimatebuilder.com/waiver_admin/notifications/`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
      method: "DELETE",
    })
      .then(response => response.json())
      .then(data => {
        if (data.res == 1) {
          setNotificationList([]);
        }
      })
      .catch(error => console.error("Error fetching file data:", error));
  };

  const deleteOneNotifications = id => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    fetch(`https://cliqestimatebuilder.com/waiver_admin/notifications/${id}`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
      method: "DELETE",
    })
      .then(response => response.json())
      .then(data => {
        if (data.res == 1) {
          let tempArray = [...notificationList];
          let selIndex = tempArray?.findIndex(item => Number(item?.id) === Number(id));
          tempArray.splice(selIndex, 1);
          setNotificationList(tempArray);
        }
      })
      .catch(error => console.error("Error fetching file data:", error));
  };

  useEffect(() => {
    const timer = setInterval(() => {
      // Call the API function
      fetchNotifications();
    }, 6000); // 6000 milliseconds = 6 seconds

    // Clear the timer when the component unmounts
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    // Retrieve user data from local storage
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);
    fetchNotifications();
  }, []);

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent">
          <div className="viewBox notificationDiv">
            <h2>Notifications</h2>
            <Link to="" className="rmvAll" onClick={() => deleteAllNotifications()}>
              Remove all
            </Link>
            <ul>
              {notificationList?.length > 0 ? (
                notificationList?.map((item, index) => (
                  <li key={index}>
                    <div className="notiLft">
                      <h3>{item?.created_at}</h3>
                      <p>{item?.message}</p>
                    </div>
                    <div className="notiRgt">
                      {/* <button>
                      <Link to="/view-one-file">
                        <img src={viewIcon} alt="View" />
                      </Link>
                    </button> */}
                      <button onClick={() => deleteOneNotifications(item?.id)}>
                        <img src={removeIcon} alt="Remove" />
                      </button>
                    </div>
                  </li>
                ))
              ) : (
                <>No notifications found.</>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
